import React, { useRef } from 'react'
import { useGetVendorAudienceDetails } from '../../../api/dealership/customers/audiences/useGetVendorAudienceDetails'
import AudienceMetricCard from './AudienceMetricCard'
import { ReactComponent as AudiencePeople } from '../../../images/icons/audience_people.svg'
import { AnimatePresence, motion, MotionConfig } from 'framer-motion'

type Props = {
  audience_id: any
  vendor_id: number
}

const GoogleVendorAudienceDetails = ({ audience_id, vendor_id }: Props): JSX.Element => {
  const { data: vendorAudience, isLoading } = useGetVendorAudienceDetails({
    audience_id: audience_id,
    filters: {
      vendor_id: vendor_id,
    },
  })

  return (
    <AnimatePresence>
      <motion.div
        className={'grid grid-cols-3 gap-5'}
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -50 }}>
        <AudienceMetricCard
          title={'Match Rate'}
          value={`${(
            vendorAudience?.vendor_audience_details?.match_rate_percentage ?? 0
          ).toString()}%`}
          isLoading={isLoading}>
          <AudienceMetricCard.Icon>
            <div className={'p-3 bg-primary-persian-blue/5 rounded-full'}>
              <AudiencePeople className={'stroke-primary-persian-blue'} />
            </div>
          </AudienceMetricCard.Icon>
        </AudienceMetricCard>
        <AudienceMetricCard
          title={'Size for Display'}
          value={
            vendorAudience?.vendor_audience_details?.size_for_display === 0
              ? '< 100'
              : new Intl.NumberFormat('en-US').format(
                  vendorAudience?.vendor_audience_details?.size_for_display ?? 0,
                )
          }
          isLoading={isLoading}>
          <AudienceMetricCard.Icon>
            <div className={'p-3 bg-primary-persian-blue/5 rounded-full'}>
              <AudiencePeople className={'stroke-primary-persian-blue'} />
            </div>
          </AudienceMetricCard.Icon>
        </AudienceMetricCard>
        <AudienceMetricCard
          title={'Size for Search'}
          value={
            vendorAudience?.vendor_audience_details?.size_for_search === 0
              ? '< 100'
              : new Intl.NumberFormat('en-US').format(
                  vendorAudience?.vendor_audience_details?.size_for_search ?? 0,
                )
          }
          isLoading={isLoading}>
          <AudienceMetricCard.Icon>
            <div className={'p-3 bg-primary-persian-blue/5 rounded-full'}>
              <AudiencePeople className={'stroke-primary-persian-blue'} />
            </div>
          </AudienceMetricCard.Icon>
        </AudienceMetricCard>
      </motion.div>
    </AnimatePresence>
  )
}

export default GoogleVendorAudienceDetails
